import { render } from "./PreJoinDock.vue.js?vue&type=template&id=62abbc4c!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PreJoinDock.vue?vue&type=template&id=62abbc4c"
import script from "./PreJoinDock.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PreJoinDock.vue?vue&type=script&lang=js"
export * from "./PreJoinDock.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PreJoinDock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/PreJoinDock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62abbc4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62abbc4c', __exports__)) {
    api.reload('62abbc4c', __exports__)
  }
  
  module.hot.accept("./PreJoinDock.vue.js?vue&type=template&id=62abbc4c!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PreJoinDock.vue?vue&type=template&id=62abbc4c", () => {
    api.rerender('62abbc4c', render)
  })

}


export default __exports__